import React, { useState } from 'react';
import styled from 'styled-components';
import { resolveMediaPath } from '@/shared/libs/resolve-media-path';
import { useBrandTheme } from '@/shared/hooks';

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const Placeholder = styled.div<{ $loaderImg:{default:string,mobile:string}}>`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  z-index: 1;
    background-image: url(${({ $loaderImg }) =>
     $loaderImg?.default});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  top: 0;
  left: 0;

  @media (max-width: 768px) {
    background-image: url(${({ $loaderImg  }) =>
       $loaderImg?.mobile});
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

const LazyImage = ({
  src,
  alt,
  placeholderContent,
  className,
  fill,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { assets:{loader} } = useBrandTheme();

  return (
    <ImageWrapper className={className}>
      {!isLoaded && <Placeholder $loaderImg={loader}>{placeholderContent}</Placeholder>}

      <StyledImage
        src={resolveMediaPath(src)}
        alt={alt}
        {...props}
        loading="lazy"
        onLoad={() => setIsLoaded(true)}
      />
    </ImageWrapper>
  );
};

export { LazyImage };
